<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();

const { field } = useInlineBlockEditor(props.id);

const placeholder = field<string>("placeholder", "");
const multiline = field<boolean>("multiline", false);
const rows = field<number>("rows", 3);
const autogrow = field<boolean>("autogrow", false);
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:text-cursor-input" accent="assessment">
    <EditorField :label="t('placeholderLabel')">
      <Input
        v-model="placeholder"
        class="h-8 rounded-sm bg-muted text-[13px]"
        :placeholder="t('placeholderPlaceholder')"
      />
    </EditorField>

    <EditorField :label="t('inputTypeLabel')">
      <Select :model-value="multiline" @update:model-value="(v) => (multiline = v as boolean)">
        <SelectTrigger class="h-8 rounded-sm bg-muted text-[13px]">
          <SelectValue :placeholder="t('inputTypeLabel')" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem :value="false">{{ t("singleLine") }}</SelectItem>
          <SelectItem :value="true">{{ t("multiLine") }}</SelectItem>
        </SelectContent>
      </Select>
    </EditorField>

    <template v-if="multiline">
      <EditorField :label="t('rowsLabel')">
        <Input type="number" min="1" v-model.number="rows" class="h-8 rounded-sm bg-muted text-[13px]" />
      </EditorField>
      <EditorField :label="t('autogrowLabel')">
        <div class="flex items-center justify-between">
          <span class="text-[12.5px] text-muted-foreground">{{ t("autogrowHint") }}</span>
          <Switch v-model="autogrow" />
        </div>
      </EditorField>
    </template>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "Textbox"
  placeholderLabel: "Placeholder Text"
  placeholderPlaceholder: "Enter placeholder text"
  inputTypeLabel: "Input Type"
  singleLine: "Single Line"
  multiLine: "Multi Line"
  rowsLabel: "Number of Rows"
  autogrowLabel: "Auto-grow"
  autogrowHint: "Grow with content"
</i18n>
